import { GetAuthTokenResponse } from 'application-types';
import { constructUrl, request, Res, UPLOAD_ENDPOINT } from './common';
import { authorizationHeader } from 'lane-shared/helpers/formatters';
import { HEADER_CHANNEL_INTEGRATION_ID } from 'constants-activate';

export interface WorkOrderAttachment {
  /** unique key that will be returned in onClose() */
  id?: string;
  file_association_id?: string;
  display_name: string;
  thumbnail?: string;
  created_at?: string;
  category?: {
    name: string;
  };
}

export type ListResData = WorkOrderAttachment[];

export interface ListParams {
  work_order_id: string;
}

export interface FileParams {
  file_id: string;
  file_association_id: string;
}

export async function get(
  token: string,
  params: ListParams,
  options?: {
    getAuthToken?: GetAuthTokenResponse,
    enableTokenManagement?: boolean,
    channelIntegrationId?: string
  }
): Promise<Res<ListResData>> {
  return request({
    token,
    method: 'get',
    path: `/work_orders/${params.work_order_id}/files`,
    getAuthToken: options?.getAuthToken,
    enableTokenManagement: options?.enableTokenManagement,
    channelIntegrationId: options?.channelIntegrationId,
  });
}

export async function deleteFile(
  token: string,
  fileParams: FileParams,
  options?: {
    getAuthToken?: GetAuthTokenResponse,
    enableTokenManagement?: boolean,
    channelIntegrationId?: string
  }
): Promise<Res<void>> {
  return request({
    token,
    method: 'delete',
    path: `/files/${fileParams.file_id}/associations/${fileParams.file_association_id}`,
    getAuthToken: options?.getAuthToken,
    enableTokenManagement: options?.enableTokenManagement,
    channelIntegrationId: options?.channelIntegrationId,
  });
}

export async function post(
  token: string,
  work_order_id: string,
  file: Blob,
  fileName: string,
  options?: {
    getAuthToken?: GetAuthTokenResponse,
    enableTokenManagement?: boolean,
    channelIntegrationId?: string
  }
): Promise<any> {
  const url = constructUrl({
    endpoint: UPLOAD_ENDPOINT,
    reqPath: `/work_orders/${work_order_id}/files?${fileName}`,
  });

  const headers: Record<string, string> = {};

  if (options?.getAuthToken && options?.enableTokenManagement) {
    const authToken = await options.getAuthToken();

    headers['Authorization'] = authorizationHeader(authToken);
    headers['x-ssologin'] = 'true';
  } else if (token) {
    headers['X-BE-Authorization'] = `Bearer ${token}`;
  }

  if (options?.channelIntegrationId) {
    headers[HEADER_CHANNEL_INTEGRATION_ID] = options.channelIntegrationId;
  }

  return fetch(url, {
    method: 'post',
    headers,
    body: file,
  });
}
